export default "__VITE_ASSET__DOreRh_J__"